import { Ref } from 'react';
import { StyledLinkAnimationText } from '~/shared/styles/Link';
import { StyledLink } from './styled';

type Props = {
    brand: string;
    brandUrl: string;
    onRouting: () => void;
    ref?: Ref<HTMLAnchorElement>;
};

export const BrandSuggestion = ({ brand, brandUrl, onRouting, ref }: Props) => {
    return (
        <li>
            <StyledLink
                href={brandUrl}
                multipleElements
                ref={ref}
                onClick={onRouting}
                animation="reverse"
            >
                <StyledLinkAnimationText>
                    <span className="subtitle">Brands / </span>
                    <span className="brandSuggestion">{brand}</span>
                </StyledLinkAnimationText>
            </StyledLink>
        </li>
    );
};
